import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  templateUrl: 'navigation.component.html'
})
export class NavigationComponent implements OnInit {
   @Input() systemCode: string;
   @Input() controller: string;
   @Input() action: string;

    public Html: any = {
        "IsSelected": function (controllerName, actionName) {
            return controllerName == this.controller && actionName == this.action? "active" : "";
        }
    };

    public Url: any = {
        "Action": function (actionName, controllerName) {
            return "App/" + controllerName + "/" + actionName;
        }
    };

   constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

}
